import Firebase from 'firebase'
import { toast } from 'react-toastify'

import { getDocFromQuery } from '../data/db_util'

const killPlayer = ({game, playerId}) => {
  return getPlayer({game, playerId})
    .then(markPlayerDead)
    .catch(error => {
      console.error('Could not kill player', error)
      toast.error('Hm, we couldn\'t kill you--try again in a minute?')
    })
}

const getPlayer = ({game, playerId}) => {
  return Firebase.firestore().collection('players')
    .where('game', '==', game.id)
    .where('user', '==', playerId)
    .get()
}

const markPlayerDead = playerRef => {
  const playerId = getDocFromQuery(playerRef).id
  return Firebase.firestore().collection('players').doc(playerId).update({
    alive: false,
  })
}

export default killPlayer



// WEBPACK FOOTER //
// ./src/actions/killPlayer.js